export default __webpack_public_path__ + "src/assets/images/graph_arrow_right.png";